import { Link } from 'react-router-dom'
import { Lock } from 'lucide-react'
import type { Tier } from '@/hooks/useEntitlements'

const TIER_LABEL: Record<Tier, string> = {
  anonymous: 'an account',
  free: 'the Free plan',
  pro: 'Pro',
  max: 'Max',
  ultra: 'Ultra',
  team: 'Team',
  enterprise: 'Enterprise',
}

/**
 * Shown by the route guard when a feature is SHIPPED but the user's plan tier is
 * too low (`needs_upgrade`) — distinct from a not-yet-launched feature, which is
 * simply hidden. Gives the user a path forward instead of a silent redirect.
 */
export function UpgradePrompt({ requiredTier }: { requiredTier: Tier | null }) {
  const need = requiredTier ? TIER_LABEL[requiredTier] : 'a higher plan'
  return (
    <div className="flex h-[60vh] items-center justify-center px-6 text-center">
      <div className="max-w-md space-y-4">
        <Lock className="mx-auto h-10 w-10 text-white/40" aria-hidden="true" />
        <h1 className="text-xl font-semibold text-white/90">This feature needs {need}</h1>
        <p className="text-sm text-white/60">
          It’s included on {need} and above. Upgrade your plan to unlock it.
        </p>
        <div className="flex items-center justify-center gap-3 pt-2">
          <Link
            to="/billing"
            className="rounded-md bg-yellow-500 px-4 py-2 text-sm font-medium text-black hover:bg-yellow-400"
          >
            Upgrade
          </Link>
          <Link
            to="/dashboard"
            className="rounded-md border border-white/15 px-4 py-2 text-sm text-white/70 hover:bg-white/5"
          >
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  )
}
